import { Box, Container, styled } from '@mui/material';
import { PoolLink } from '@synergy/components-next';
import { ReactElement } from 'react';

import { FooterLink } from '../../../models/footer-link';

const Wrapper = styled(Box)(({ theme }) => ({
    height: 56,
    backgroundColor: theme.palette.grey[900],
    color: theme.palette.grey[400],

    [theme.breakpoints.up('sm')]: {
        height: 40,
    },
}));

const StyledContainer = styled(Container)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '100%',

    [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-between',
        padding: 0,
    },
}));

const StyledPoolLink = styled(PoolLink)(({ theme }) => ({
    padding: theme.spacing(1, 2),

    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(1, 2.5),
        '&:last-child': {
            marginRight: -20,
        },
    },
}));

export const FooterBottom = ({ links }: { links: FooterLink[] }): ReactElement => {
    return (
        <Wrapper>
            <StyledContainer maxWidth="xl" data-testid="page-bottom">
                {links.map((link, index) => {
                    return (
                        <StyledPoolLink key={index} colorVariant="grey400" href={link.url} id={link.elementId}>
                            {link.title}
                        </StyledPoolLink>
                    );
                })}
            </StyledContainer>
        </Wrapper>
    );
};
